jQuery(() => {
  // Initialize carousel on thumbnails
  jQuery('.more-views ul').owlCarousel({
    itemsCustom: [
      [0, 4],
      [1024, 8]
    ],
    navigation: true,
    pagination: false,
    navigationText: [
      '<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'
    ],
    autoPlay: 10000,
    stopOnHover: true
  })

  const thumbs = document.querySelectorAll('.more-views .owl-item a')
  if (thumbs) {
    thumbs.forEach(thumb => thumb.addEventListener('click', function () {
      thumbs.forEach(thumb => thumb.classList.remove('active'))
      this.classList.add('active')
    }))
  }
})
